import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronDown, ChevronUp, LogOut, Menu, User, X } from "lucide-react";

interface MenuBarProps {
  user: {
    email: string;
  };
  sidebarOpen?: boolean;
  onToggleSidebar?: () => void;
}

export const MenuBar = ({
  user,
  sidebarOpen,
  onToggleSidebar,
}: MenuBarProps) => {
  // State for user settings dropdown
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const navigate = useNavigate();
  // Toggle user dropdown
  const toggleUserDropdown = () => {
    setUserDropdownOpen(!userDropdownOpen);
  };

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      {/* Top menu bar */}
      <header className="bg-slate-900 text-white shadow-sm h-16 flex items-center justify-between px-4 z-10">
        {/* Sidebar drawer toggle, only below md */}
        {onToggleSidebar && (
          <button
            className="md:hidden flex-none mr-3 p-2 -ml-2 rounded-md hover:bg-slate-800 transition-colors"
            onClick={onToggleSidebar}
            aria-label={sidebarOpen ? "Close menu" : "Open menu"}
            aria-expanded={sidebarOpen}
          >
            {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        )}
        <span className="text-3xl max-md:text-xl max-md:truncate max-md:min-w-0">
          OMG<b>YES</b>: Admin Portal
        </span>
        {/* User dropdown in top-right */}
        <div className="ml-auto relative max-md:flex-none">
          <button
            className="flex items-center space-x-2 px-3 py-2 rounded-md hover:bg-slate-800 transition-colors"
            onClick={toggleUserDropdown}
            aria-label="Account menu"
          >
            <div className="bg-gray-200 rounded-full p-2">
              <User size={18} className="text-gray-600" />
            </div>
            <span className="font-medium max-md:hidden">{user?.email}</span>
            {userDropdownOpen ? (
              <ChevronUp size={16} className="text-gray-600" />
            ) : (
              <ChevronDown size={16} className="text-gray-600" />
            )}
          </button>

          {/* User dropdown menu */}
          {userDropdownOpen && (
            <div className="right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 fixed max-md:z-40">
              {/* The email is hidden in the bar below md, so show it here */}
              <div className="md:hidden px-4 py-2 text-gray-500 text-sm truncate border-b">
                {user?.email}
              </div>
              <div
                className="px-4 py-2 text-gray-700 hover:bg-gray-100 flex items-center"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/logout");
                }}
              >
                <LogOut size={16} className="mr-2" />
                Log out
              </div>
            </div>
          )}
        </div>
      </header>
    </div>
  );
};
